__webpack_require__.p = "https://uat.dm366f18z6ank.amplifyapp.com/";